// Copyright (c) 2026 SoundDrift. All rights reserved.

import React from 'react';
import { APP_VERSION } from '../../utils/version.js';

export function isInsideIframe() {
  try {
    return typeof window !== 'undefined' && window.self !== window.top;
  } catch (e) {
    return true;
  }
}

export default function Footer({ style = {}, showLinks = true }) {
  if (isInsideIframe()) {
    return null;
  }

  return (
    <footer
      data-testid="app-footer"
      style={{
        marginTop: '32px',
        padding: '16px 0 24px',
        fontSize: '0.75rem',
        color: 'var(--sd-dim, #6E7982)',
        textAlign: 'center',
        width: '100%',
        boxSizing: 'border-box',
        ...style
      }}
    >
      <div>© 2026 memedrift.com. All rights reserved.</div>
      {showLinks && (
        <div style={{ marginTop: '8px' }}>
          <a href="/privacy.html" target="_blank" rel="noreferrer" style={{ color: 'inherit', textDecoration: 'underline', margin: '0 8px' }}>Privacy Policy</a>
          |
          <a href="/terms.html" target="_blank" rel="noreferrer" style={{ color: 'inherit', textDecoration: 'underline', margin: '0 8px' }}>Terms of Service</a>
        </div>
      )}
      <div
        data-testid="app-version-tag"
        style={{
          marginTop: '6px',
          fontSize: '0.65rem',
          fontFamily: "var(--sd-font-mono, 'IBM Plex Mono'), monospace",
          opacity: 0.65
        }}
      >
        {APP_VERSION}
      </div>
    </footer>
  );
}
